import { create } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';
import axios from 'axios';

export interface CryptoPrice {
  symbol: string;
  price: number;
  priceChange: number;
  volume: number;
  lastUpdate: number;
  isFavorite?: boolean;
}

interface CryptoStore {
  prices: Record<string, CryptoPrice>;
  topPrices: Record<string, CryptoPrice>;
  favorites: string[];
  isConnected: boolean;
  error: string | null;
  selectedChart: string | null;
  startStream: () => void;
  stopStream: () => void;
  toggleFavorite: (symbol: string, name: string) => Promise<void>; 
  getFavorites: () => CryptoPrice[];
  setSelectedChart: (symbol: string | null) => void;
  initializeFavorites: () => Promise<void>; 
}

type CryptoPersist = Pick<CryptoStore, 'favorites'>;

const persistConfig: PersistOptions<CryptoStore, CryptoPersist> = {
  name: 'crypto-favorites',
  partialize: (state) => ({
    favorites: state.favorites,
  }),
};

export const useCryptoStore = create<CryptoStore>()(
  persist(
    (set, get) => ({
      prices: {},
      topPrices: {},
      favorites: [],
      isConnected: false,
      error: null,
      selectedChart: null,
      
      setSelectedChart: (symbol) => set({ selectedChart: symbol }),

      initializeFavorites: async () => {
        try {
          const token = localStorage.getItem('token');
          if (!token) return;

          const response = await axios.get('http://31.210.36.47:5002/api/favorites', {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          
          const favorites = response.data.map((coin: any) => coin.symbol + 'USDT');
          set({ favorites });
        } catch (error) {
          console.error('Favoriler yüklenirken hata:', error);
        }
      },

      toggleFavorite: async (symbol: string, name: string) => {
        try {
          const token = localStorage.getItem('token');
          if (!token) {
            throw new Error('Oturum açmanız gerekiyor');
          }

          const response = await axios.post(
            'http://31.210.36.47:5002/api/favorites/toggle',
            {
              symbol: symbol.replace('USDT', ''),
              name: name || symbol.replace('USDT', '')
            },
            {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          );

          if (response.data.success) {
            const favorites = response.data.favorites.map((coin: any) => coin.symbol + 'USDT');
            set({ favorites });
          } else {
            throw new Error(response.data.message);
          }
        } catch (error) {
          console.error('Favori işlemi sırasında hata:', error);
          throw error;
        }
      },

      getFavorites: () => {
        const { prices, favorites } = get();
        return favorites
          .map(symbol => prices[symbol])
          .filter(Boolean);
      },

      startStream: () => {
        try {
          const ws = new WebSocket('wss://stream.binance.com:9443/ws/!miniTicker@arr');
          set({ isConnected: true, error: null });

          ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            const currentPrices = get().prices;
            const updatedPrices = { ...currentPrices };
            
            data.forEach((item: any) => {
              if (item.s.endsWith('USDT')) {
                const symbol = item.s;
                updatedPrices[symbol] = {
                  ...updatedPrices[symbol],
                  symbol: symbol.replace('USDT', ''),
                  price: parseFloat(item.c),
                  priceChange: ((parseFloat(item.c) - parseFloat(item.o)) / parseFloat(item.o)) * 100,
                  volume: parseFloat(item.v) * parseFloat(item.c),
                  lastUpdate: Date.now(),
                  isFavorite: get().favorites.includes(symbol)
                };
              }
            });

            const topVolumePairs = Object.entries(updatedPrices)
              .sort(([, a], [, b]) => b.volume - a.volume)
              .slice(0, 12)
              .reduce((acc, [key, value]) => ({
                ...acc,
                [key]: value
              }), {});

            set({ 
              prices: updatedPrices,
              topPrices: topVolumePairs
            });
          };

          ws.onerror = (error) => {
            console.error('WebSocket hatası:', error);
            set({ 
              error: 'Bağlantı kesildi, yeniden bağlanılıyor...',
              isConnected: false 
            });
            ws.close();
            
            setTimeout(() => {
              useCryptoStore.getState().startStream();
            }, 5000);
          };

          ws.onclose = () => {
            set({ isConnected: false });
          };

        } catch (error) {
          set({ 
            error: 'Bağlantı başlatılamadı',
            isConnected: false 
          });
        }
      },

      stopStream: () => {
        set({ 
          isConnected: false, 
          prices: {}, 
          topPrices: {},
          selectedChart: null
        });
      }
    }),
    persistConfig
  )
);